<template>
    <div id="ResultDownload" class="base">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke"></div>
        </div>
        <div class="regist-area">
            <div v-if="isQueryError" id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                    <div style="color: whitesmoke">
                        指定されたページはURLが間違っているか、有効期限が切れています。
                    </div>
                </div>
            </div>
            <div v-else-if="!isAuthed" id="item-contens">
                <div class="card-content auth-area">
                    <div style="font-size: 20px; color: whitesmoke">パスワード</div>
                    <input type="password" v-model="password"/>
                    <div v-if="authFaild" class="authFaild">パスワードが違います</div>
                    <b-button class="opbutton" icon-left="chevron-double-right" @click="auth">ログイン</b-button>
                </div>
            </div>
            <div v-else id="item-contens">
                <div class="card-content summaryArea">
                    <div style="font-size: 20px; color: whitesmoke">申込み概要</div>
                    <table class="summaryTable">
                        <tr><th>申請者</th><td>{{data.clientName}}</td></tr>
                        <tr><th>申請日</th><td>{{data.applicationDate}}</td></tr>
                        <tr><th>検査種別</th><td>{{data.inspectionKind}}</td></tr>
                        <tr><th>医療機関名</th><td>{{data.hospitalName}}</td></tr>
                        <tr><th>患者名</th><td>{{data.patientName}}</td></tr>
                    </table>
                    <div style="font-size: 20px; color: whitesmoke; margin-top:15px;">結果ダウンロード</div>
                    <div class="fileList">
                        <ul v-if="data.historystatus == requestStatus.replaceReportFile">
                            <li>
                                只今、解析結果データ準備中です。<br>
                                後日、アクセスをお願いします。
                            </li>
                        </ul>
                        <ul v-else>
                            <li v-for="(file,index) in data.resultFileList" :key="index">
                                <a @click="downloadFile(file.filePath, file.fileId)"><b-icon icon="paperclip"/>{{file.fileName}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {requestStatus} from "@/components/mock/base/const.js";
export default {
  name: "ResultDownload",
  data() {
    var query = this.$route.query.query
    var result = this.$route.params["result"];
    return {
        data:result ? result : {},
        query:query,
        isQueryError: result ? false : true,
        isAuthed: result ? true : false,
        authFaild: false,
        password: "",
        requestStatus: requestStatus
    };
  },
  methods: {
      auth: function(){
        try {
            this.$store.dispatch("resultDownload", {
                key: this.query,
                password: this.password
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.data = result.obj;
                    this.isAuthed = true;
                } else {
                    this.authFaild = true;
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        }
      },
      downloadFile: function(filePath, fileId){
        try {
            this.$store.dispatch("downloadFile", {
                fileName: filePath,
                fileId: fileId,
                key: this.query,
                password: this.password

            }).then(result => {
                if(result != null && result.status == 200){
                    var downloadUrl = result.obj.downloadUrl;
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = downloadUrl;
                    let targetFile = filePath.toLowerCase();
                    if(targetFile.endsWith(".pdf")){
                        a.target="_blank"
                    }
                    a.click();
                    a.remove();
                } else if(result != null){
                    this.showErrorMessage(result.message);
                } else {
                    this.showErrorMessage("予期しないエラーが発生しました。");
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        }
      },
  },
  mounted: function(){
    //keyの検証
    try {
        if (this.isAuthed) {
            var userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.$store.dispatch("verifyKeyForIntroductionRequestAuth", {
              query: this.$route.query.query,
              token: userInfo.token
            }).then(result => {
                if(result != null && result.status === 200 ) {
                    this.password = JSON.parse(result.data).otp
                    this.isQueryError = false
                }
                this.isloading = false;
            }).catch(error => {
                this.isloading = false;
            });
            return;
        }

        this.$store.dispatch("verifyKey", {
            key: this.query
        }).then(result => {
            if(result != null && result.status === 200 ) {
                this.isQueryError = false
            }
            this.isloading = false;
        }).catch(error => {
            this.isloading = false;
        });
    } catch(err){
        this.isloading = false;
    }
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
.base {
    min-height: 1000px;
    background: linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
    background: -moz-linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
    background: -webkit-linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 600px;
}
.auth-area {
    width: 300px !important;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.summaryArea
{
    min-height: 450px;
}
.summaryTable {
    margin: 0 50px;
}
.summaryTable th {
    color: whitesmoke !important;
    width: 150px !important;
}
.summaryTable td
{
    color: whitesmoke !important;
}
.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.authFaild{
    margin-top:5px;
    color:tomato;
}
.opbutton {
    margin-top:10px;
    width: 100px;
}
.fileList 
{
  margin: 5px 30px;
  padding: 20px;
  text-align: left;
  border-radius: 10px;
  background-color: whitesmoke;
}
.fileList li{
  margin-top: 5px;
  margin-bottom: 5px;
} 
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/ResultDownload.vue